import { MutationTree } from 'vuex';
import { IDeal } from '@/dealboard/types/deal';
import { IDealboardState } from '@/dealboard/store/dealboard.store';

export const mutationSetLoading = 'setLoading';
export const mutationSetDeals = 'setDeals';
export const mutationSetBank = 'setBank';
export const mutationAddToBank = 'addToBank';
export const mutationSetPagination = 'setPagination';
export const mutationToggleReminder = 'toggleReminder';

export const mutations: MutationTree<IDealboardState> = {
  [mutationSetLoading](state: IDealboardState, loading: boolean) {
    state.isLoading = loading;
  },
  [mutationSetDeals](state: IDealboardState, deals: IDeal[]) {
    state.deals = deals;
  },
  [mutationSetBank](state: IDealboardState, payload: { totalValue: number; deals: IDeal[] }) {
    if (payload.deals) {
      state.dealBank = payload.deals;
    }
    if (payload.totalValue !== undefined) {
      state.totalValue = payload.totalValue;
    }
  },
  [mutationAddToBank](state: IDealboardState, payload: { totalValue: number; deals: IDeal[] }) {
    state.dealBank = [...state.dealBank, ...payload.deals];
  },
  [mutationSetPagination](
    state: IDealboardState,
    pagination: { currentPage: number; pageSize: number }
  ) {
    state.pagination = { ...pagination };
  },
  [mutationToggleReminder](
    state: IDealboardState,
    payload: { documentId: string; reminderValue: boolean }
  ) {
    const deal: IDeal = state.deals.find((deal: IDeal) => deal.document.id === payload.documentId);
    if (deal) {
      deal.document.isReminderSending = payload.reminderValue;
    }
  },
};
